import executeRequest, { RequestOutput } from 'app/api'
import { APIPaginatable, APIPaginatableResponse, APISortable, APISearchable } from 'app/api/types'

enum APIEndpoint {
  GetAllVessels = 'api/vessels',
  GetVesselById = 'api/vessels/getById',
  CreateVessel = 'api/vessels/create',
  UpdateVessel = 'api/vessels/update',
  DeleteVessel = 'api/vessels/delete',
}

export interface API_Vessel {
  id: number
  mmsi?: string | null
  name?: string | null
  imoNumber?: string | null
  isTrackingActive?: boolean | null
}



export interface GetAllVesselsRequestParams extends APIPaginatable, APISortable, APISearchable {
}
export interface GetAllVesselsResponse extends APIPaginatableResponse {
  vessels: API_Vessel[]
}
enum GetAllVesselsResponseError {
}
export async function getAllVessels(params: GetAllVesselsRequestParams, output?: RequestOutput<GetAllVesselsResponse, GetAllVesselsResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.GetAllVessels,
    params: params,
    output: output,
  })
}



export type GetVesselRequestParams = {
  id: number
}
export type GetVesselResponse = {
  vessel: API_Vessel
}
enum GetVesselResponseError {
}
export async function getVessel(params: GetVesselRequestParams, output?: RequestOutput<GetVesselResponse, GetVesselResponseError>) {
  executeRequest({
    endpoint: APIEndpoint.GetVesselById,
    params: params,
    output: output,
  })
}



export type CreateVesselRequestParams = {
}
type CreateVesselResponse = {
  vessel: API_Vessel
}
enum CreateVesselReponseError {
}
export async function createVessel(params: CreateVesselRequestParams, output?: RequestOutput<CreateVesselResponse, CreateVesselReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.CreateVessel,
    params: params,
    output: output,
  })
}



export interface UpdateVesselRequestParams extends API_Vessel {
}
type UpdateVesselResponse = {
}
enum UpdateVesselReponseError {
}
export async function updateVessel(params: UpdateVesselRequestParams, output?: RequestOutput<UpdateVesselResponse, UpdateVesselReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.UpdateVessel,
    params: params,
    output: output,
  })
}



export type DeleteVesselRequestParams = {
  id: number
}
type DeleteVesselResponse = {
}
enum DeleteVesselReponseError {
}
export async function deleteVessel(params: DeleteVesselRequestParams, output?: RequestOutput<DeleteVesselResponse, DeleteVesselReponseError>) {
  executeRequest({
    endpoint: APIEndpoint.DeleteVessel,
    params: params,
    output: output,
  })
}